import {
  MotifButton,
} from '../../assets/lib/motif';
import { useMsal } from '@azure/msal-react';
import { useDispatch, useSelector } from 'react-redux';
import { releaseAlllocks } from '../../store/services/engagement.service';
import { signOut } from '../../store/services/user.service';
import { dropEngagementState, dropSelectedRegion } from '../../store/slices/engagementSlice';
import { dropStepperState } from '../../store/slices/stepperSlice';
import { dropProjectState } from '../../store/slices/projectSlice';
import { dropSimulateState } from '../../store/slices/simulateSlice';
import { dropDecarbLibraryState } from '../../store/slices/decarbLibrarySlice';
import { dropSetupState } from '../../store/slices/setupSlice';
import { dropForecastState } from '../../store/slices/forecastSlice';
import { routes } from '../../routes/routes.constatns';
import { onHideLogOutModal } from '../../store/slices/logoutSlice';
import { LOGOUTMODALMESSAGE } from '../../util/constants';
import {Modal} from '../CommonUIComponents/Modal/Modal';
import './LogoutModal.scss'


function ModalHeader() {
  return (
    <div className="logout-modal-header">
      <span>{LOGOUTMODALMESSAGE}</span>
    </div>
  );
}

const LogoutModal = () => {
  const { instance } = useMsal();
  const logoutShow = useSelector(state => state.logoutModal.isShowLogoutModal);
  const user = useSelector(state => state.user.user);
  const dispatch = useDispatch();

  const logoutfn = async () => {
    await releaseAlllocks({ request: { email: user.username } });
    // const response = await signOut();
    // if (!response) return;
    // if (response.status === 200) {
      dispatch(dropEngagementState());
      dispatch(dropStepperState());
      dispatch(dropProjectState());
      dispatch(dropSetupState());
      dispatch(dropForecastState());
      dispatch(dropSimulateState());
      dispatch(dropDecarbLibraryState());
      dispatch(dropSelectedRegion());

      instance.logoutRedirect({
        account: instance.getActiveAccount(),
        postLogoutRedirectUri: `${process.env.REACT_APP_URL_REG_ALL}${routes.home}`,
      });
    // }
  };
  
  return (
    <Modal 
      header={<ModalHeader />}
      show={logoutShow}
      className={"logout-modal"}
      footer={
         <div 
           style={{ 
             alignItems: 'center', 
             display: 'flex', 
             justifyContent: 'space-between', 
           }} 
         > 
           <div 
             style={{ 
               display: 'flex', 
               gap: '1rem', 
             }} 
           > 
             <MotifButton 
               onClick={() => { 
                 dispatch(onHideLogOutModal()); 
               }} 
               size="medium" 
               type="button" 
               variant="secondary" 
             > 
               Cancel 
             </MotifButton> 
             <MotifButton 
               className="" 
               onClick={logoutfn} 
               size="medium" 
               type="button" 
             > 
               Confirm 
             </MotifButton> 
           </div> 
         </div> 
      }
    />

  );
};

export default LogoutModal;


